import { buyOffer as o } from "../../../pages/checkout/api/index.mjs";
const p = (r, f) => o(r, f);
export {
  p as razorpayBuyOffer
};
